<template>
  <div class="payments-control-btn">
    <taskbar-button
      icon="md-filing"
      size="24"
      :show-badge="isNew"
      badge-type="error"
      :click-handler="openPaymentControlModal"
      tooltip-content="Распределение платежей из 1С"
    />

    <payment-control />
  </div>
</template>

<script>
import TaskbarButton from '@/components/parts/taskbar-button'
import PaymentControl from './payment-control'

export default {
  components: {
    TaskbarButton,
    PaymentControl
  },
  computed: {
    isNew () {
      return this.$store.state.paymentsControl.isNew
    }
  },
  methods: {
    openPaymentControlModal () {
      this.$store.commit('TOGGLE_PC_PROP', { field: 'showModal', value: true })
    }
  }
}
</script>

<style lang="less">
</style>
